import { render, staticRenderFns } from "./bo-datatable-subrecord.vue?vue&type=template&id=5848b692"
import script from "./bo-datatable-subrecord.vue?vue&type=script&lang=js"
export * from "./bo-datatable-subrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports